import * as React from 'react';
import * as _ from 'underscore';

import { MenuItemInfo, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../codegen/Localize';
import { showAddAdGroupDialog } from '../groups/services/actions/ActiveDirectoryGroupAction';
import { AddContentButton } from './AddContentButton';
import { showCreateGroupDialog } from '../groups/services/actions/CreateGroupDialogAction';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';


export interface AddGroupsButtonProps {
  readonly buttonText: string;
  readonly canSessionUserManageUsers: boolean;
}

export enum AddGroupDialogType {
  AddLocalGroup = 'addLocalGroup',
  AddADGroup = 'addADGroup'
}

const ADD_GROUPS_TEST_ID = 'action-add-groups';

function createAddGroupsMenuItemOptions(): MenuItemInfo[] {
  let menuItemInfos: MenuItemInfo[] = [];
  menuItemInfos.push({displayValue: Messages.addGroupsLocalGroupButton(), value: AddGroupDialogType.AddLocalGroup});

  if (ServerSettingsUnauthenticated.isServerDomainFamilyActiveDirectory()) {
    menuItemInfos.push({displayValue: Messages.addUsersImportAdGroupButton(), value: AddGroupDialogType.AddADGroup});
  }

  return menuItemInfos;
}

const onSelectUserOption = async (addGroupDialogType: AddGroupDialogType): Promise<void> => {
  switch (addGroupDialogType) {
    case AddGroupDialogType.AddLocalGroup:
      showCreateGroupDialog();
      break;
    case AddGroupDialogType.AddADGroup:
      toNativePromise(showAddAdGroupDialog());
      break;
    default:
      return;
  }
};

export const AddGroupsButton: React.FunctionComponent<AddGroupsButtonProps> = props => {
  return(<div>
    {props.canSessionUserManageUsers &&
    <AddContentButton
      buttonText={props.buttonText}
      testId={ADD_GROUPS_TEST_ID}
      menuItems={createAddGroupsMenuItemOptions()}
      onSelect={onSelectUserOption}
    />}
    {!props.canSessionUserManageUsers &&
    <ButtonWidget
      testId={ADD_GROUPS_TEST_ID}
      handleClick={() => onSelectUserOption(AddGroupDialogType.AddLocalGroup)}
    > {props.buttonText} </ButtonWidget>}
  </div>);
};
